export const setNationalIdentificationNumberValidations = (
  nationalIdentificationNumber: string
) => {
  const hasError = false;
  const message = "";

  if (nationalIdentificationNumber === "") {
    return {
      hasError: true,
      message: "National Identification Number (NIN/NIMC) is required",
    };
  }

  if (nationalIdentificationNumber.length < 11) {
    return {
      hasError: true,
      message: "National Identification Number (NIN/NIMC) not valid",
    };
  }

  return {
    hasError,
    message,
  };
};
